import React from 'react';

import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useHistoricalPercentageChangeWidgetConfigSlice } from '../store';
import { createGridChartViewToggleButtons } from 'utils/components/ViewToggleButtons/ViewToggleButtons.tsx';

import './HistoricalPercentageChangeWidget.scss';
import {
    HistoricalPercentageChangeWidgetSettings,
    HistoricalPercentageChangeWidgetSettingsTitle,
} from 'widgets/historicalPercentageChange/widget/components/settings/HistoricalPercentageChangeWidgetSettings.tsx';
import HistoricalPercentageChangeWidgetGridColumnPicker from 'widgets/historicalPercentageChange/widget/components/grid/HistoricalPercentageChangeWIdgetGridColumnPicker.tsx';
import {
    GridApi,
    GridExportButton,
} from '@instinet-analytics/semantic-ui-components';

export default function HistoricalPercentageChangeWidgetToolbar({
    gridApi,
}: {
    gridApi?: GridApi;
}) {
    const { config, dispatchConfigChanged } =
        useHistoricalPercentageChangeWidgetConfigSlice();

    const { view } = config;

    // const messages = useWidgetMessages();

    const onViewChanged = (nextView: 'chart' | 'grid') => {
        dispatchConfigChanged({ view: nextView });
    };

    return (
        <div className="HistoricalPercentageChangeWidgetToolbar panel-header">
            <div className="toolbar"></div>

            <WidgetToolbar
                // messages={messages}
                messages={[]}
                collapsibleItems={createGridChartViewToggleButtons(
                    view,
                    onViewChanged
                )}
                settingsHeader={HistoricalPercentageChangeWidgetSettingsTitle}
                settingsClassName="HistoricalPercentageChangeWidgetSettingsMoal"
                settingsBody={
                    <HistoricalPercentageChangeWidgetSettings
                        config={config}
                        onConfigChanged={dispatchConfigChanged}
                    />
                }
                fixedItems={
                    view === 'grid' ? (
                        <>
                            <GridExportButton
                                csvFileName={'HistoricalPercentageChange'}
                                gridApi={gridApi}
                            />
                            <HistoricalPercentageChangeWidgetGridColumnPicker />
                        </>
                    ) : undefined
                }
            />
        </div>
    );
}
